import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components/macro';
import { Button, ButtonGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import find from 'lodash/find';
import filter from 'lodash/filter';
import {
  PROPERTY_ATMORE,
  PROPERTY_MONTGOMERY,
  PROPERTY_WETUMPKA,
  PROPERTY_BETHLEHEM
} from 'utils/constants';

const propertyAmenities = {
  [PROPERTY_ATMORE]: [
    { value: 'Miller Lite - $6', label: 'Miller Lite - $6' },
    { value: 'Coors Light - $6', label: 'Coors Light - $6' },
    { value: 'Bud Light - $6', label: 'Bud Light - $6' },
    { value: 'Budweiser - $6', label: 'Budweiser - $6' },
    { value: 'Michelob Ultra - $6', label: 'Michelob Ultra - $6' },
    { value: 'Stella - $7', label: 'Stella - $7' },
    { value: 'Corona - $7', label: 'Corona - $7' },
    { value: 'Heineken - $7', label: 'Heineken - $7' },
    { value: 'Yuengling - $7', label: 'Yuengling - $7' },
    { value: 'Crown Royal Whiskey - $78', label: 'Crown Royal - $78' },
    { value: 'Crown Reserve Whiskey - $99', label: 'Crown Reserve - $99' },
    { value: 'Jack Daniels Whiskey - $70', label: 'Jack Daniels - $70' },
    { value: 'Jim Beam Whiskey - $46', label: 'Jim Beam - $46' },
    { value: 'Dettling Whiskey - $70', label: 'Dettling - $70' },
    { value: 'Courvoisier - $65', label: 'Courvoisier - $65' },
    { value: 'Grand Marnier - $97', label: 'Grand Marnier - $97' },
    { value: 'Hennessy - $95', label: 'Hennessy - $95' },
    { value: 'Remy Martin VSOP - $82', label: 'Remy Martin VSOP - $82' },
    { value: 'Absolut - $104', label: 'Absolut - $104' },
    { value: 'Ciroc - $96', label: 'Ciroc - $96' },
    { value: 'Grey Goose - $89', label: 'Grey Goose - $89' },
    { value: "Tito's - $65", label: "Tito's - $65" },
    { value: 'Bombay Sapphire - $78', label: 'Bombay Sapphire - $78' },
    { value: 'Tanqueray - $70', label: 'Tanqueray - $70' },
    {
      value: 'Chivas Regal Scotch - $103',
      label: 'Chivas Regal Scotch - $103'
    },
    {
      value: "DeWar's White Label Scotch - $81",
      label: "DeWar's White Label Scotch - $81"
    },
    {
      value: 'Johnnie Walker Black Scotch - $117',
      label: 'Johnnie Walker Black Scotch - $117'
    },
    { value: 'Bacardi Light Rum - $43', label: 'Bacardi Light - $43' },
    { value: 'Myers Dark Rum - $46', label: 'Myers Dark Rum - $46' },
    { value: 'Malibu Coconut Rum- $50', label: 'Malibu Coconut Rum - $50' },
    {
      value: 'Patron Silver Tequila - $127',
      label: 'Patron Silver Tequila - $127'
    },
    {
      value: 'Jose Cuervo Gold Tequila - $62',
      label: 'Jose Cuervo Gold - $62'
    },
    {
      value: '1800 Reposado Tequila - $67',
      label: '1800 Reposado Tequila - $67'
    },
    {
      value: 'Brut Korbel Champagne - $32',
      label: 'Brut Korbel Champagne - $32'
    },
    {
      value: 'Imperial Moet & Chandon Champagne - $100',
      label: 'Imperial Moet & Chandon Champagne - $100'
    },
    {
      value: 'Dom Perignon Champagne - $350',
      label: 'Dom Perignon Champagne - $350'
    },
    {
      value: 'Cristal Champagne - $781.25',
      label: 'Cristal Champagne - $781.25'
    },
    { value: 'Salon Champagne - $369', label: 'Salon Champagne - $369' },
    {
      value: "Bailey's Irish Cream - $85",
      label: "Bailey's Irish Cream - $85"
    },
    { value: 'CK Mondavi Merlot - $23', label: 'CK Mondavi Merlot - $23' },
    {
      value: 'CK Mondavi Cabernet Savignon - $23',
      label: 'CK Mondavi Cabernet Savignon - $23'
    },
    { value: 'Hess Select - $32', label: 'Hess Select - $32' },
    { value: 'Peju - $57', label: 'Peju - $57' },
    { value: 'King Estate Oregon - $55', label: 'King Estate Oregon - $55' },
    {
      value: 'Sin Zin, Alexander Valley - $42',
      label: 'Sin Zin, Alexander Valley - $42'
    },
    {
      value: 'CK Mondavi Chardonnay - $23',
      label: 'CK Mondavi Chardonnay - $23'
    },
    { value: 'Jordan Chardonnay - $64', label: 'Jordan Chardonnay - $64' },
    {
      value: 'Santa Margherita Pinot Grigio - $55',
      label: 'Santa Margherita Pinot Grigio- $55'
    },
    { value: 'Kabinett Riesling - $55', label: 'Kabinett Riesling - $55' },
    {
      value: 'CK Mondavi White Zinfandel - $23',
      label: 'CK Mondavi White Zinfandel - $23'
    },
    {
      value: '99 Vines White Zinfandel - $20',
      label: '99 Vines White Zinfandel - $20'
    },
    { value: '20oz Btl. Pepsi - $3.75', label: '20oz Btl. Pepsi - $3.75' },
    {
      value: '20oz Btl. Diet Pepsi - $3.75',
      label: '20oz Btl. Diet Pepsi - $3.75'
    },
    { value: '20oz Btl. Sunkist - $3.75', label: '20oz Btl. Sunkist - $3.75' },
    {
      value: '20oz Btl. Sierra Mist - $3.75',
      label: '20oz Btl. Sierra Mist - $3.75'
    },
    {
      value: '20oz Btl. Dr. Pepper - $3.75',
      label: '20oz Btl. Dr. Pepper - $3.75'
    },
    {
      value: '20oz Btl. Diet Dr. Pepper - $3.75',
      label: '20oz Btl. Diet Dr. Pepper - $3.75'
    },
    {
      value: '20oz Btl. Lemonade - $3.75',
      label: '20oz Btl. Lemonade - $3.75'
    },
    {
      value: '20oz Btl. Mountain Dew - $3.75',
      label: '20oz Btl. Mountain Dew - $3.75'
    },
    { value: '12 oz. Can Coke - $4', label: '12 oz. Can Coke - $4' },
    { value: '12 oz. Can Diet Coke - $4', label: '12 oz. Can Diet Coke - $4' },
    { value: '12 oz. Can Sprite - $4', label: '12 oz. Can Sprite - $4' },
    { value: 'Apple Juice - $5.50', label: 'Apple Juice - $5.50' },
    { value: 'Orange Juice - $5.50', label: 'Orange Juice - $5.50' },
    { value: 'Tomato Juice - $5.50', label: 'Tomato Juice - $5.50' },
    { value: 'Grapefruit Juice - $5.50', label: 'Grapefruit Juice - $5.50' },
    { value: 'Cranberry Juice - $5.50', label: 'Cranberry Juice - $5.50' },
    { value: 'Pineapple Juice - $5.50', label: 'Pineapple Juice - $5.50' },
    { value: 'Milk - $3.25', label: 'Milk - $3.25' },
    { value: 'Coffee (Pitcher) - $9.75', label: 'Coffee (Pitcher) - $9.75' },
    {
      value: 'Decaf Coffee (Pitcher) - $9.75',
      label: 'Decaf Coffee (Pitcher) - $9.75'
    },
    { value: 'Bottle Water - $3.25', label: 'Bottle Water - $3.25' },
    { value: 'Tonic - $3.00', label: 'Tonic - $3.00' },
    {
      value: 'Chocolate Dipped Strawberries - $26.00',
      label: 'Chocolate Dipped Strawberries - $26.00'
    },
    {
      value: 'Dipped Strawberries w/ Champagne - $60.00',
      label: 'Dipped Strawberries w/ Champagne - $60.00'
    },
    { value: 'Deli Tray - $28.00', label: 'Deli Tray - $28.00' },
    { value: 'Fruit Tray - $26.00', label: 'Fruit Tray - $26.00' },
    { value: 'Cheese Tray - $36.00', label: 'Cheese Tray - $36.00' },
    { value: 'Fruit Bowl - $6.50', label: 'Fruit Bowl - $6.50' },
    {
      value: 'Fruit Tray w/ Champagne - $60.00',
      label: 'Fruit Tray w/ Champagne - $60.00'
    },
    {
      value: 'Cookie Tray with Cold Milk - $18.00',
      label: 'Cookie Tray with Cold Milk - $18.00'
    },
    { value: 'Chips - $2.00', label: 'Chips - $2.00' },
    {
      value: 'Cookie Tray (6ct) - $12.00',
      label: 'Cookie Tray (6ct) - $12.00'
    },
    { value: 'Muffin - $6.50', label: 'Muffin - $6.50' },
    { value: 'Danish - $6.50', label: 'Danish - $6.50' }
  ],
  [PROPERTY_MONTGOMERY]: [
    {
      value: 'Chocolate Dipped Strawberries (6 ea) - $24',
      label: 'Chocolate Dipped Strawberries (6 ea) - $24'
    },
    {
      value: 'Cheese Platter (2ppl) - $36',
      label: 'Cheese Platter (2ppl) - $36'
    },
    {
      value: 'Fresh Cut Fruit Platter (2ppl) - $24',
      label: 'Fresh Cut Fruit Platter (2ppl) - $24'
    },
    {
      value: 'Fruit and Cheese Platter (2ppl) - $36',
      label: 'Fruit and Cheese Platter (2ppl) - $36'
    },
    {
      value: 'Wind Creek Deli Tray w/ French Bread - $30',
      label: 'Wind Creek Deli Tray w/ French Bread - $30'
    },
    { value: 'Soda & Juice (ea) - $3', label: 'Soda & Juice (ea) - $3' },
    { value: 'Dasani - $6', label: 'Dasani - $6' },
    { value: 'Champagne - $35', label: 'Champagne - $35' },
    { value: 'Ciroc - $133', label: 'Ciroc - $133' },
    { value: 'Crown Royal - $78', label: 'Crown Royal - $78' },
    { value: 'Grey Goose - $130', label: 'Grey Goose - $130' },
    { value: 'Hennessy - $125', label: 'Hennessy - $125' },
    { value: 'Patron Tequila - $138', label: 'Patron Tequila - $138' },
    { value: 'Tanqueray - $70', label: 'Tanqueray - $70' },
    { value: 'House Chardonnay - $35', label: 'House Chardonnay - $35' },
    { value: 'House Merlot - $35', label: 'House Merlot - $35' },
    { value: 'Birthday Dessert - $12', label: 'Birthday Dessert - $12' },
    { value: 'Anniversary Package - $50', label: 'Anniversary Package - $50' }
  ],
  [PROPERTY_WETUMPKA]: [
    {
      value: 'Dark Chocolate Dipped Strawberries - $29.22',
      label: 'Dark Chocolate Dipped Strawberries - $29.22'
    },
    {
      value: 'Dipped Strawberry W/Champagne - $70.62',
      label: 'Dipped Strawberry W/Champagne - $70.62'
    },
    {
      value: 'Cheese & Crackers Platter - $46.47',
      label: 'Cheese & Crackers Platter - $46.47'
    },
    {
      value: 'Fresh Fruit Platter - $31.52',
      label: 'Fresh Fruit Platter - $31.52'
    },
    {
      value: 'Fresh Fruit Platter W/Champagne - $76.37',
      label: 'Fresh Fruit Platter W/Champagne - $76.37'
    },
    {
      value: 'Soda & Water Bottle - $6.22',
      label: 'Soda & Water Bottle - $6.22'
    },
    { value: 'Juice - $7.37', label: 'Juice - $7.37' },
    { value: 'Korbel Champagne - $38.42', label: 'Korbel Champagne - $38.42' },
    { value: 'Merlot - $38.42', label: 'Merlot - $38.42' },
    { value: 'Cabernet - $51.07', label: 'Cabernet - $51.07' },
    { value: 'White Zinfandel - $45.32', label: 'White Zinfandel - $45.32' },
    { value: 'Chardonnay - $57.97', label: 'Chardonnay - $57.97' },
    { value: 'Moscato - $38.42', label: 'Moscato - $38.42' },
    { value: 'Crown Royal - $91.32', label: 'Crown Royal - $91.32' },
    { value: 'Grey Goose - $154.57', label: 'Grey Goose - $154.57' },
    { value: 'Patron Tequila - $148.82', label: 'Patron Tequila - $148.82' },
    { value: 'Bacardi - $51.07', label: 'Bacardi - $51.07' },
    { value: 'Jack Daniels - $82.12', label: 'Jack Daniels - $82.12' },
    { value: 'Domestic 6 Pack - $36.12', label: 'Domestic 6 Pack - $36.12' },
    { value: 'Import 6 Pack - $43.02', label: 'Import 6 Pack - $43.02' }
  ],
  [PROPERTY_BETHLEHEM]: [
    {
      value: 'Chocolate dipped Strawberries ½ dozen - $15',
      label: 'Chocolate dipped Strawberries ½ dozen - $15'
    },
    {
      value: 'Chocolate dipped Strawberries 1 dozen - $28',
      label: 'Chocolate dipped Strawberries 1 dozen - $28'
    },
    {
      value: 'Freshly Baked Cookie Platter	$20 - .00',
      label: 'Freshly Baked Cookie Platter	$20 - .00'
    },
    {
      value: 'Whole Seasonal Fruit Bowl	$24 - .00',
      label: 'Whole Seasonal Fruit Bowl	$24 - .00'
    },
    {
      value: 'Sliced Array of Seasonal Fruits and Berries - $12',
      label: 'Sliced Array of Seasonal Fruits and Berries - $12'
    },
    {
      value: 'Domestic and Imported Artisan Cheese Board - $36',
      label: 'Domestic and Imported Artisan Cheese Board - $36'
    },
    {
      value: 'Artisan Charcuterie Platter - $38',
      label: 'Artisan Charcuterie Platter - $38'
    },
    {
      value: 'Mixed Nut/Trail Mix Bowl - $10',
      label: 'Mixed Nut/Trail Mix Bowl - $10'
    },
    { value: 'Snacks Bowl - $48', label: 'Snacks Bowl - $48' },
    { value: 'Sweets Bowl - $60', label: 'Sweets Bowl - $60' },
    { value: 'Candy Tray - $18', label: 'Candy Tray - $18' },
    { value: 'Chocolate Tray - $18', label: 'Chocolate Tray - $18' },
    { value: 'Coke - $4', label: 'Coke - $4' },
    { value: 'Diet Coke - $4', label: 'Diet Coke - $4' },
    { value: 'Sprite - $4', label: 'Sprite - $4' },
    { value: 'Ginger Ale - $4', label: 'Ginger Ale - $4' },
    { value: 'Tonic - $4', label: 'Tonic - $4' },
    { value: 'Club - $4', label: 'Club - $4' },
    {
      value: 'Fiji Water (1/2 Liter) - $5',
      label: 'Fiji Water (1/2 Liter) - $5'
    },
    {
      value: 'Fiji Water (1 Liter)	$6 - .50',
      label: 'Fiji Water (1 Liter)	$6 - .50'
    },
    { value: 'Pellegrino (8.45oz) - $5', label: 'Pellegrino (8.45oz) - $5' },
    { value: 'Orange Juice - $5', label: 'Orange Juice - $5' },
    { value: 'Cranberry Juice - $5', label: 'Cranberry Juice - $5' },
    { value: 'Grapefruit Juice - $5', label: 'Grapefruit Juice - $5' },
    { value: 'Red Bull - $5', label: 'Red Bull - $5' },
    { value: 'Sugar Free Red Bull - $5', label: 'Sugar Free Red Bull - $5' },
    { value: 'Blueberry Red Bull - $5', label: 'Blueberry Red Bull - $5' },
    {
      value: 'Coconut Berry Red Bull - $5',
      label: 'Coconut Berry Red Bull - $5'
    },
    { value: 'Lamberti Prosecco - $40', label: 'Lamberti Prosecco - $40' },
    {
      value: 'Veuve Clicquot Yellow Label - $124',
      label: 'Veuve Clicquot Yellow Label - $124'
    },
    {
      value: 'Moet Nectar Imperial Rose - $143',
      label: 'Moet Nectar Imperial Rose - $143'
    },
    { value: 'Dom Perignon - $378', label: 'Dom Perignon - $378' },
    {
      value: 'Clos du Bois Chardonnay - $43',
      label: 'Clos du Bois Chardonnay - $43'
    },
    {
      value: 'Santa Margarita Pinot Grigio - $57',
      label: 'Santa Margarita Pinot Grigio - $57'
    },
    {
      value: 'Dr. L "Loosen" Riesling - $31',
      label: 'Dr. L "Loosen" Riesling - $31'
    },
    {
      value: 'Kenwood Sauvignon Blanc - $43',
      label: 'Kenwood Sauvignon Blanc - $43'
    },
    {
      value: 'Franciscan Estates Cabernet Savignon - $55',
      label: 'Franciscan Estates Cabernet Savignon - $55'
    },
    {
      value: 'Jordan Cabernet Savignon - $150',
      label: 'Jordan Cabernet Savignon - $150'
    },
    {
      value: 'Caymus Cabernet Savignon - $221',
      label: 'Caymus Cabernet Savignon - $221'
    },
    {
      value: 'Silver Oak Alexander Valley Cabernet Savignon - $246',
      label: 'Silver Oak Alexander Valley Cabernet Savignon - $246'
    },
    {
      value: 'Far Niente Cabernet Savignon - $383',
      label: 'Far Niente Cabernet Savignon - $383'
    },
    {
      value: 'Caymus Special Selection Cabernet Savignon - $411',
      label: 'Caymus Special Selection Cabernet Savignon - $411'
    },
    {
      value: 'Opus I Cabernet Savignon - $748',
      label: 'Opus I Cabernet Savignon - $748'
    },
    { value: 'Meiomi Pinot Noir - $55', label: 'Meiomi Pinot Noir - $55' },
    {
      value: "Antinori Tignanello '14 Pinot Noir - $300",
      label: "Antinori Tignanello '14 Pinot Noir - $300"
    },
    {
      value: 'Whispering Angel Rosé - $58',
      label: 'Whispering Angel Rosé - $58'
    },
    {
      value: 'Wente "Sandstone" Rosé - $44',
      label: 'Wente "Sandstone" Rosé - $44'
    },
    { value: 'Tito’s, US - $46', label: 'Tito’s, US - $46' },
    {
      value: 'Ketel One, Netherlands - $60',
      label: 'Ketel One, Netherlands - $60'
    },
    { value: 'Ciroc, France - $73', label: 'Ciroc, France - $73' },
    { value: 'Grey Goose, France - $76', label: 'Grey Goose, France - $76' },
    {
      value: 'Bombay Sapphire, England - $69',
      label: 'Bombay Sapphire, England - $69'
    },
    { value: 'Hendricks - $89', label: 'Hendricks - $89' },
    {
      value: 'Patron Silver, Mexico - $127',
      label: 'Patron Silver, Mexico - $127'
    },
    {
      value: 'Casamigos Reposado, Mexico - $118',
      label: 'Casamigos Reposado, Mexico - $118'
    },
    {
      value: 'Don Julio 1942, Mexico - $313',
      label: 'Don Julio 1942, Mexico - $313'
    },
    {
      value: 'Johnnie Walker Black, Scotland - $94',
      label: 'Johnnie Walker Black, Scotland - $94'
    },
    {
      value: 'Johnnie Walker 18 Year, Scotland - $225',
      label: 'Johnnie Walker 18 Year, Scotland - $225'
    },
    {
      value: 'Johnnie Walker Blue, Scotland - $568',
      label: 'Johnnie Walker Blue, Scotland - $568'
    },
    {
      value: 'The Glenlivet 12, Scotland - $127',
      label: 'The Glenlivet 12, Scotland - $127'
    },
    {
      value: 'The Glenlivet 18, Scotland - $285',
      label: 'The Glenlivet 18, Scotland - $285'
    },
    {
      value: 'The Macallan 12 Year - $160',
      label: 'The Macallan 12 Year - $160'
    },
    {
      value: 'The Macallan 18 Year - $763',
      label: 'The Macallan 18 Year - $763'
    },
    {
      value: 'Jim Beam, United States - $53',
      label: 'Jim Beam, United States - $53'
    },
    {
      value: 'Jack Daniels, United States - $58',
      label: 'Jack Daniels, United States - $58'
    },
    {
      value: 'Jack Daniels Honey, United States - $55',
      label: 'Jack Daniels Honey, United States - $55'
    },
    {
      value: 'Fireball Cinnamon Whiskey, US - $44',
      label: 'Fireball Cinnamon Whiskey, US - $44'
    },
    { value: 'Jameson, Ireland - $75', label: 'Jameson, Ireland - $75' },
    {
      value: 'Bacardi, Puerto Rico - $37',
      label: 'Bacardi, Puerto Rico - $37'
    },
    {
      value: 'Captain Morgan, US V.I. - $44',
      label: 'Captain Morgan, US V.I. - $44'
    },
    { value: 'Malibu Coconut - $40', label: 'Malibu Coconut - $40' },
    { value: 'Hennessy XO - $392', label: 'Hennessy XO - $392' },
    { value: 'Remy Martin XO - $390', label: 'Remy Martin XO - $390' },
    { value: 'Domestic Beer - $7', label: 'Domestic Beer - $7' },
    { value: 'Premium Beer - $8', label: 'Premium Beer - $8' },
    { value: 'Super Premium Beer - $9', label: 'Super Premium Beer - $9' }
  ]
};

const AmenitiesWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;
    position: relative;

    ul {
    }
  `}
`;

const AmenitiesList = styled.ul`
  ${({ theme }) => css`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 12.5rem;
    overflow-y: scroll;
    z-index: 1;

    flex: 1 0 auto;
    border: 1px solid #ccc;
    border-top: 0;
    border-radius: 0 0 0.125rem;
    background: ${props => props.theme.colors.white};
    list-style: none;
    padding: 0.125rem;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.25rem;
      background: ${props => props.theme.colors.white};
      border-bottom: 1px solid #ccc;

      .btn-group {
        flex-basis: 20%;
      }

      input {
        background: rgba(255, 255, 255, 0.5);
        border: 0;
      }
    }
  `}
`;

const ItemName = styled.span`
  flex: 1 0 20%;
  padding-right: 0.5rem;
`;

const ItemQuantity = styled.span`
  flex: 0 1 20%;
`;

const AmenitiesButton = styled.button`
  background: ${props => props.theme.colors.white};
  border: 1px solid #000;
  line-height: 2rem;
  padding: 0 0.625rem;
  text-align: left;

  .fa-caret-up,
  .fa-caret-down {
    color: #999;
    position: absolute;
    height: 100%;
    top: 0;
    right: 0.75rem;

    &:hover {
      color: #666;
    }
  }
`;

function AmenityRequests({ input, id, property }) {
  const [showAmenities, setShowAmenities] = useState(false);

  const { onChange, value } = input;

  const addItem = amenity => {
    const newAmenity = find(value, { value: amenity.value }) || amenity;
    const newSelectedAmenities = value
      ? filter(value, item => item.value !== amenity.value)
      : [];

    onChange([
      ...newSelectedAmenities,
      {
        ...newAmenity,
        quantity: !isNaN(newAmenity.quantity) ? newAmenity.quantity + 1 : 1
      }
    ]);
  };

  const subtractItem = amenity => {
    const newAmenity = find(value, { value: amenity.value }) || amenity;
    const newSelectedAmenities = value
      ? filter(value, item => item.value !== amenity.value)
      : [];

    const updatedAmenity = {
      ...newAmenity,
      quantity: !isNaN(newAmenity.quantity)
        ? Math.max(0, newAmenity.quantity - 1)
        : 0
    };

    updatedAmenity.quantity > 0
      ? onChange([...newSelectedAmenities, updatedAmenity])
      : onChange([...newSelectedAmenities]);
  };

  // Closes amenities if the click is outside the amenities wrapper.
  const handleClick = e => {
    const id = 'amenities-wrapper';

    if (
      showAmenities &&
      e.target instanceof HTMLElement &&
      document.getElementById(id) !== null &&
      !document.getElementById(id).contains(e.target)
    ) {
      setShowAmenities(!showAmenities);
    }
  };

  useEffect(() => {
    // initiate the event handler
    window.addEventListener('click', handleClick);

    // this will clean up the event every time the component is re-rendered
    return function cleanup() {
      window.removeEventListener('click', handleClick);
    };
  });

  const handleAmenitiesButtonClick = e => {
    e.preventDefault();

    setShowAmenities(!showAmenities);
  };

  const options = property ? propertyAmenities[property] : [];

  return (
    <AmenitiesWrapper id="amenities-wrapper">
      <AmenitiesButton onClick={handleAmenitiesButtonClick}>
        Select Amenities...
        <FontAwesomeIcon
          icon={showAmenities ? 'caret-up' : 'caret-down'}
          role="presentation"
        />
      </AmenitiesButton>
      {showAmenities && (
        <AmenitiesList>
          <li>
            <ItemName>Item</ItemName>
            <ItemQuantity>Qty</ItemQuantity>
            <span className="btn-group"></span>
          </li>
          {options.map((amenity, i) => (
            <li key={`amenity-${i}`}>
              <ItemName>{amenity.label}</ItemName>
              <ItemQuantity>
                {find(value, { value: amenity.value })?.quantity || 0}
              </ItemQuantity>
              <ButtonGroup>
                <Button
                  color="danger"
                  className="amenities-button"
                  onClick={() => subtractItem(amenity)}
                >
                  <FontAwesomeIcon icon="minus" role="presentation" />
                </Button>
                <Button
                  color="success"
                  className="amenities-button"
                  onClick={() => addItem(amenity)}
                >
                  <FontAwesomeIcon icon="plus" role="presentation" />
                </Button>
              </ButtonGroup>
            </li>
          ))}
        </AmenitiesList>
      )}
    </AmenitiesWrapper>
  );
}

export default AmenityRequests;
